import React from 'react';

export default function PinIcon({ width = 16, height = 16, fill = '#171C33' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 5.06992L3 7.16992M1.84383 2.76236V3.40155C1.84383 3.46395 1.84383 3.49516 1.83792 3.525C1.83269 3.55148 1.82403 3.5771 1.81218 3.60117C1.79883 3.6283 1.78005 3.65267 1.74248 3.7014L1.28875 4.29007C1.09632 4.53972 1.00011 4.66455 1 4.7696C0.999905 4.86096 1.03993 4.94739 1.10872 5.00438C1.18783 5.06992 1.34184 5.06992 1.64988 5.06992H4.35012C4.65816 5.06992 4.81217 5.06992 4.89128 5.00438C4.96007 4.94739 5.0001 4.86096 5 4.7696C4.99989 4.66455 4.90368 4.53972 4.71125 4.29007L4.25752 3.7014C4.21995 3.65267 4.20117 3.6283 4.18782 3.60117C4.17597 3.5771 4.16731 3.55148 4.16208 3.525C4.15617 3.49516 4.15617 3.46395 4.15617 3.40155V2.76236C4.15617 2.72782 4.15617 2.71056 4.15806 2.69353C4.15973 2.6784 4.1625 2.66342 4.16637 2.64873C4.17071 2.63219 4.17689 2.61616 4.18925 2.58409L4.48057 1.82819C4.56556 1.60766 4.60805 1.4974 4.59033 1.40889C4.57483 1.33148 4.53053 1.26355 4.46704 1.21987C4.39444 1.16992 4.28002 1.16992 4.05118 1.16992H1.94882C1.71998 1.16992 1.60556 1.16992 1.53296 1.21987C1.46947 1.26355 1.42517 1.33148 1.40967 1.40889C1.39195 1.4974 1.43444 1.60766 1.51943 1.82819L1.81075 2.58409C1.82311 2.61616 1.82929 2.63219 1.83363 2.64873C1.8375 2.66342 1.84027 2.6784 1.84195 2.69353C1.84383 2.71056 1.84383 2.72782 1.84383 2.76236Z"
        stroke={fill}
        strokeWidth="0.74"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
